export const transformOrderId = (orderId = "", orgId = "") => {
  if (orderId.includes(`fds_${orgId}`)) {
    const items = orderId.split("_")
    const orderOriginalId = orderId.replace(`fds_${orgId}_`, "").split("_")[0]
    return `${orderOriginalId}${items.length === 5 ? `_${Number(items[4])}` : ""}`
  } else {
    return orderId
  }
}
